import { useState, useEffect, useCallback } from 'react'
import { doRequestGet } from '../../api';
import { doToast, promiseCatch } from '../../utils';
import { toast } from 'react-toastify';

export const useGet = ({
  url, execute = true, callback = () => {}
}) => {
  const [isProcessing, setIsProccesing] = useState(true)
  const [rows, setRows] = useState([]);
  const [reload, setReload] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])

  const fetchData = useCallback(async () => {
    try {
      setIsProccesing(true)
      setError(false)
      const getRows = await doRequestGet({
        url: url
      })
      if (getRows.response === 'success') {
        setRows(getRows.data)
        callback(getRows.data)
      } else {
        doToast({
          ...getRows,
          toast
        })
      }
    } catch (error) {
      setRows([]);
      setError(true);
    } finally {
      setIsProccesing(false);
      setReload(false);
    }
  }, [url])

  useEffect(() => {
    if (reload && execute) {
      fetchData()
    } else {
      setIsProccesing(false);
      setReload(false);
    }
  }, [reload, fetchData, execute])

  return {
    setRows,
    rows,
    isProcessing,
    setReload,
    error,
    setError
  }
}